import { createAssign } from "robodux";
import { spawn, takeLeading } from "saga-query";

import i18n from "@app/i18n";

import { inApi } from "../apis/api";
import { RootState } from "../rootState";
import { appNotify } from "../units/notify";

import type { TIvFiscal } from "@app/types/insider";
const t = i18n.t.bind(i18n);
const DOWNLOADED_REPO = "insiderDownloads";
import type { ApiCtx, Next } from "saga-query";
export const repo = createAssign({
  name: DOWNLOADED_REPO,
  initialState: {
    FE_ID: 0,
  },
});

const sendNotification = function* (message: string, duration = 5000) {
  yield* spawn(appNotify.run, appNotify({ type: "error", message, duration }));
};

export const dowloadInvoice_v0 = inApi.post<TIvFiscal>(
  "instorage/downloadInvoice_v0",
  { saga: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const { FE_ID, FF_ID, FISIER } = ctx.payload;
    console.log("FE_ID", FE_ID);
    if (!FE_ID || !FISIER || !FF_ID) {
      yield* sendNotification(t("badparameters"), 3000);
      return;
    }
    ctx.bodyType = "blob";
    ctx.request = ctx.req({
      method: "POST",
      url: `/assets/downloadInvoice`,
      body: JSON.stringify({
        FF_ID,
      }),
    });
    yield* next();
    if (ctx.response?.status !== 200) {
      console.log("dude");
      yield* sendNotification(t("download_error"), 3000);
      return;
    }
    const { data, ok } = yield ctx.json;
    console.log("data", data);
    if (!ok) {
      yield* sendNotification(t("download_error"), 3000);
      return;
    }
    try {
      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = FISIER;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e: any) {
      const errorMessage = "message" in e ? e.message : t("download_error");
      yield* sendNotification(errorMessage);
    }
  }
);

export const dowloadInvoice = inApi.post<TIvFiscal>(
  "instorage/downloadInvoice",
  { saga: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const { FE_ID, FF_ID, FISIER } = ctx.payload;

    if (!FE_ID || !FF_ID || !FISIER) {
      yield* sendNotification(t("badparameters"), 3000);
      return;
    }

    ctx.bodyType = "blob";
    ctx.request = ctx.req({
      method: "POST",
      url: `/assets/downloadInvoice`,
      body: JSON.stringify({ FF_ID }),
    });

    yield* next();

    if (ctx.response?.status !== 200) {
      yield* sendNotification(t("download_error"), 3000);
      return;
    }

    try {
      const { data, ok } = yield ctx.json;
      if (!ok) {
        throw new Error(t("download_error"));
      }

      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank"); // Opens in a new tab to use browser's PDF viewer
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : t("download_error");
      yield* sendNotification(errorMessage, 3000);
    }
  }
);

const irepoSelectors = (s: RootState) => s[DOWNLOADED_REPO];
